import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Grid,
    Typography,
    Box,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    CircularProgress,
    createTheme,
    ThemeProvider,
    Card,
    CardContent,
    Snackbar,
    Input, FormHelperText
} from '@mui/material';
import { styled } from '@mui/system';

const CustomInputLabel = styled(InputLabel)({
    color: 'rgba(255, 255, 255, 0.7)',
});

const CustomButton = styled(Button)({
    backgroundColor: '#E90FF',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '6px',
    '&:hover': {
        backgroundColor: '#E90FF',
    },
});

const API_URL = process.env.REACT_APP_API_URL;

function SectionApply({ userId, onLogout, formData, submittedData }) {

    const [sectionId, setSectionId] = useState('');

    const [subsectionId, setSubsectionId] = useState('');

    const [sections, setSections] = useState([]);
    const [subsections, setSubsections] = useState([]);

    const [customSectionName, setCustomSectionName] = useState('');
    const [customSubsectionName, setCustomSubsectionName] = useState('');

    const [selectedDate, setSelectedDate] = useState('');
    const [availableSlots, setAvailableSlots] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState('');

    const [videoLink, setVideoLink] = useState('');
    const [isValid, setIsValid] = useState(true); // Track if the link is valid

    const [error, setError] = useState([])
    const [loading, setLoading] = useState(false);

    const handleCustomSectionChange = (event) => {
        setCustomSectionName(event.target.value);
    };

    const handleCustomSubsectionChange = (event) => {
        setCustomSubsectionName(event.target.value);
    };

    useEffect(() => {
        axios.get(`${API_URL}/list_sections_and_subsections/?user_id=${userId}&available_sections_is_true=${true}`)
            .then((response) => {

                if (response.data && response.data.sections) {
                    const fetchedSections = Object.entries(response.data.sections).map(([sectionName, sectionData]) => ({
                        sectionName,
                        sectionId: sectionData.section_id,
                        subsections: sectionData.subsections,
                    }));


                    setSections(fetchedSections);
                } else {
                    console.error("Sections data is missing in the response!");
                }
            })
            .catch((error) => {
                console.error('Error fetching sections:', error);
            });
    }, []);

    const handleSectionChange = (event) => {
        const selectedSectionId = event.target.value;
        setSectionId(selectedSectionId);


        const selectedSection = sections.find(section => section.sectionId === selectedSectionId);
        setSubsections(selectedSection ? selectedSection.subsections : []);
        setSubsectionId('');
    };

    const handleSubsectionChange = (event) => {
        setSubsectionId(event.target.value);
    };

    const validateLink = (link) => {
        const youtubePattern = /^(https?:\/\/)?(www\.)?(youtube|youtu|youtube-nocookie)\.(com|be)\/.+$/;
        const googleDrivePattern = /^(https?:\/\/)?(drive\.google\.com\/).*$/;
        return youtubePattern.test(link) || googleDrivePattern.test(link);
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        setVideoLink(value);

        if (validateLink(value)) {
            setIsValid(true);
            setError('');
        } else {
            setIsValid(false);
            setError('Please enter a valid YouTube or Google Drive link.');
        }
    };

    const handleRedirect = () => {
        window.location.href = '/video-creation-guidelines'; // Use window.location for redirection
    };

    const handlePost = () => {
        const selectedSection = sections.find(section => section.sectionId === sectionId);
        const sectionName = selectedSection ? selectedSection.sectionName : '';


        const selectedSubsection = subsections.find(subsection => subsection.id === subsectionId);
        const subsectionName = selectedSubsection ? selectedSubsection.name : '';





        const postData = {
            user_id: userId,
            subsection_id: subsectionId,
            is_active: true,
            status: 'pending',
            selected_date: selectedDate,
            video_link: "https://www.youtube.com/"
        };



        axios.post(`${API_URL}/create_user_section_verification/`, postData).then((response) => {
            showAlert()
            window.location.reload();
        })
            .catch((error) => {
                setError('An error occurred while applying. Please try again later.');
            });
    };

    const showAlert = () => {
        const alertDiv = document.createElement('div');
        alertDiv.textContent = 'Applied for section verification successfully!';
        alertDiv.style.position = 'fixed';
        alertDiv.style.top = '10px';
        alertDiv.style.left = '50%';
        alertDiv.style.transform = 'translateX(-50%)';
        alertDiv.style.padding = '10px 20px';
        alertDiv.style.backgroundColor = 'green';
        alertDiv.style.color = 'white';
        alertDiv.style.borderRadius = '5px';
        alertDiv.style.zIndex = '9999';
        alertDiv.style.fontSize = '16px';

        document.body.appendChild(alertDiv);

        setTimeout(() => {
            alertDiv.remove();
        }, 3000);
    };


    return (
        <div>
            <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" component="h1" sx={{ fontWeight: 'bold', color: 'white' }}>
                    Stage 3: Section Apply
                </Typography>

            </Box>
            <Box
                sx={{
                    backgroundColor: '#2222', // Dark background color for contrast (adjusted from '#2222')
                    borderRadius: 2, // Rounded corners for a soft look
                    boxShadow: 2, // Subtle shadow to make it pop out a bit
                    padding: { xs: '1rem', sm: '1.5rem', md: '2rem' }, // Responsive padding
                    marginBottom: 2, // Space below the container
                    width: '100%', // Ensure it takes full width
                    maxWidth: '900px', // Limit the maximum width for readability
                    marginX: 'auto', // Center the container horizontally
                    display: 'flex', // Ensure flexbox layout (optional if you want to add child items)
                    flexDirection: 'column', // Organize child items in a column layout (if needed)
                }}
            >
                <Typography
                    variant="body1"
                    color="text.primary"
                    paragraph
                    sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem', lg: '1.2rem' }, // Adjust font size for different screen sizes
                        marginBottom: { xs: '0.5rem', sm: '1rem', md: '1.5rem' }, // Adjust margin-bottom for different screen sizes
                        lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 }, // Adjust line-height for readability on smaller screens
                        fontWeight: 'bold', // Make the headings stand out
                    }}
                >
                    <strong>Approved Subcategories:</strong>
                    {submittedData.approved_sections ? (
                        Array.isArray(submittedData.approved_sections) ? (
                            submittedData.approved_sections.map((section, index) => (
                                <div key={index}>{section}</div> // Render each section in a new line
                            ))
                        ) : typeof submittedData.approved_sections === 'string' ? (
                            submittedData.approved_sections.split(/[\s,]+/).map((section, index) => (
                                <div key={index}>{section}</div> // Render each section in a new line
                            ))
                        ) : (
                            "Invalid Data Type" // If the type is neither string nor array
                        )
                    ) : (
                        "Not Provided" // Fallback message if no approved sections
                    )}
                </Typography>


                <Typography
                    variant="body1"
                    color="text.primary"
                    paragraph
                    sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem', lg: '1.2rem' },
                        marginBottom: { xs: '0.5rem', sm: '1rem', md: '1.5rem' },
                        lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 },
                    }}
                >
                    <strong>Applied Subcategories:</strong> {submittedData.pending_sections || "Not Provided"}
                </Typography>
            </Box>

            {submittedData.pending_sections.length === 0 ? (
                <Box
                    sx={{
                        width: '100%', // Take full width of the container
                        maxWidth: '900px', // Set a maximum width for the box
                        marginX: 'auto', // Center the box horizontally
                        padding: { xs: '1rem', sm: '1.5rem', md: '2rem' }, // Responsive padding
                    }}
                >

                    <Typography
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem', lg: '1.7rem' },  // Adjust font size for different screen sizes
                            lineHeight: 1.5,  // Optional: You can adjust the line height to ensure text is readable
                            padding: { xs: '10px', sm: '15px', md: '20px' },  // Adjust padding for responsiveness
                            textAlign: 'center'  // Optional: Center the text on all screens (if desired)
                        }}
                    >
                        Please select one category and subcategory for which posting access is required.
                    </Typography>


                    <FormControl fullWidth sx={{ marginBottom: '1.5rem', marginTop: '1.5rem' }}>
                        <CustomInputLabel>Select Category</CustomInputLabel>
                        <Select
                            value={sectionId}
                            onChange={handleSectionChange}
                            label="Select Category"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.7)',
                                border: '2px solid #9999',
                            }}
                        >
                            {sections.map((section) => (
                                <MenuItem key={section.sectionId} value={section.sectionId}>
                                    {section.sectionName}
                                </MenuItem>
                            ))}
                            <MenuItem value="other">Other</MenuItem>
                        </Select>
                    </FormControl>

                    {sectionId === 'other' && (
                        <FormControl fullWidth sx={{ marginBottom: '1.5rem' }}>
                            <CustomInputLabel>Enter Custom Category</CustomInputLabel>
                            <Input
                                value={customSectionName}
                                onChange={handleCustomSectionChange}
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    border: '2px solid #9999',
                                    width: '100%', // Make it fill the width of its container
                                    padding: '0.8rem', // Adjust padding for better spacing
                                    fontSize: '1rem', // Set default font size
                                    '@media (max-width: 600px)': {
                                        fontSize: '0.875rem', // Smaller font size on small screens
                                        padding: '0.5rem', // Less padding on small screens
                                    },
                                    '@media (min-width: 600px) and (max-width: 900px)': {
                                        fontSize: '0.95rem', // Medium size font for tablets
                                        padding: '0.7rem',
                                    },
                                    '@media (min-width: 900px)': {
                                        fontSize: '1rem', // Larger font for desktops
                                        padding: '0.8rem',
                                    },
                                }}
                            />

                        </FormControl>
                    )}


                    {subsections.length > 0 && (
                        <Box sx={{ marginBottom: '1.5rem' }}>
                            <FormControl fullWidth sx={{ marginBottom: '1.5rem', marginTop: '1rem' }}>
                                <CustomInputLabel>Select Subcategory</CustomInputLabel>
                                <Select
                                    value={subsectionId}
                                    onChange={handleSubsectionChange}
                                    label="Select Subcategory"
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.7)',
                                        border: '2px solid #9999',
                                    }}
                                >
                                    {subsections.map((subsection) => (
                                        <MenuItem key={subsection.id} value={subsection.id}>
                                            {subsection.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {subsectionId === 'other' && (
                                <FormControl fullWidth sx={{ marginBottom: '1.5rem' }}>
                                    <CustomInputLabel>Enter Custom Subcategory</CustomInputLabel>
                                    <Input
                                        value={customSubsectionName}
                                        onChange={handleCustomSubsectionChange}
                                        sx={{
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            border: '2px solid #9999',
                                            width: '100%', // Make it fill the container
                                            padding: '0.8rem', // Default padding
                                            fontSize: '1rem', // Default font size
                                            '@media (max-width: 600px)': {
                                                fontSize: '0.875rem', // Smaller font size for small screens (mobile)
                                                padding: '0.5rem', // Less padding for small screens
                                            },
                                            '@media (min-width: 600px) and (max-width: 900px)': {
                                                fontSize: '0.95rem', // Medium font size for tablets
                                                padding: '0.7rem', // Medium padding for tablets
                                            },
                                            '@media (min-width: 900px)': {
                                                fontSize: '1rem', // Default or larger font size for desktops
                                                padding: '0.8rem', // Default or larger padding for desktops
                                            },
                                        }}
                                    />

                                </FormControl>)}



                        </Box>
                    )}


                    <Grid container justifyContent="center">
                        <CustomButton
                            onClick={handlePost}
                            disabled={loading}
                            sx={{
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#1565c0',
                                },
                                '&.Mui-disabled': {
                                    backgroundColor: '#90caf9',
                                },
                            }}
                        >
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Apply'}
                        </CustomButton>
                    </Grid>

                </Box>
            ) : (
                <Box>
                    {submittedData.interview_details && submittedData.interview_details.length > 0 ? (
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="body1" gutterBottom>
                                    <strong>Interview Date:</strong> {new Date(submittedData.interview_details[0].interview_slot).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric',
                                    })}
                                </Typography>


                                <Typography variant="body1" gutterBottom>
                                    <strong>Interview Time:</strong> {new Date(submittedData.interview_details[0].interview_slot).toLocaleTimeString('en-US', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true  // Ensures AM/PM format
                                    })}
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    href={submittedData.interview_details[0].meeting_link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Join Now
                                </Button>
                            </CardContent>
                        </Card>
                    ) : (
                        ''
                    )}
                    <Typography
                        variant="h6"
                        color="warning.main"
                        gutterBottom
                        sx={{
                            fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' }, // Adjusts font size for better readability across devices
                            lineHeight: { xs: 1.5, sm: 1.6, md: 1.8 }, // Adjusts line height to improve readability
                            paddingX: { xs: 3, sm: 4, md: 5 }, // Adds responsive horizontal padding
                            textAlign: 'center', // Always center-aligns text
                            background: 'linear-gradient(45deg, #ff6f00, #ff9800)', // Gradient background for a modern touch
                            color: 'transparent', // Keeps the text color transparent so the gradient can show
                            backgroundClip: 'text', // Clips the background to the text
                            fontWeight: 'bold', // Makes the font bold for emphasis
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Adds a subtle shadow to make it pop
                            borderRadius: 2, // Rounded corners for a modern design
                            transition: 'all 0.3s ease', // Smooth transition for hover effect
                            maxWidth: '800px', // Limits the max width for better text alignment
                            margin: '0 auto', // Centers the text horizontally
                            '&:hover': {
                                transform: 'scale(1.05)', // Slight zoom-in effect on hover
                                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)', // Increases shadow on hover
                                background: 'linear-gradient(45deg, #ff6f00, #ff9800)',
                                color: '#ffffff', // Change text color to white on hover for readability
                            },
                        }}
                    >
                        Thank you for applying. We will review your request and get back to you as soon as possible. Please keep visiting this page to know the status.
                    </Typography>


                </Box>
            )
            }
        </div>
    )
}

export default SectionApply
